import orderBy from "lodash/orderBy";

import {
	CommitmentFilterType
} from "@teaming/common-enums";

export const SHORT_DATE_FORMAT = "MMM D"; // e.g.: Jan 30

export const commitmentFilterOrder = Object.freeze( {
	[ CommitmentFilterType.OUTSTANDING ]: 0,
	[ CommitmentFilterType.OVERDUE ]: 2,
	[ CommitmentFilterType.NO_DUE_DATE ]: 3,
	[ CommitmentFilterType.DUE_IN_NEXT_WEEK ]: 4,
	[ CommitmentFilterType.COMPLETE ]: 5,
} );

export const filterSorts = {
	[ CommitmentFilterType.COMPLETE ]: commitments => {
		return orderBy(
			commitments,
			[ "completedDateStamp", "content", ],
			[
				"desc", // most recently completed first
				"asc",
			]
		);
	},
	[ CommitmentFilterType.DUE_IN_NEXT_WEEK ]: commitments => {
		return orderBy(
			commitments,
			[ "createdDateStamp", "content", ],
			[ "asc", "asc", ] // oldest first
		);
	},
	[ CommitmentFilterType.NO_DUE_DATE ]: commitments => {
		return orderBy(
			commitments,
			[ "createdDateStamp", "content", ],
			[ "asc", "asc", ] // oldest first
		);
	},
	[ CommitmentFilterType.OUTSTANDING ]: commitments => {
		return orderBy(
			commitments,
			[ "dueDateStamp", "content", "createdDateStamp", ],
			[
				"asc", // coming due soonest first
				"asc", // alphabetical
				"asc", // oldest first
			]
		);
	},
	[ CommitmentFilterType.OVERDUE ]: commitments => {
		return orderBy(
			commitments,
			[ "createdDateStamp", "content", ],
			[ "asc", "asc", ] // oldest first
		);
	},
};
